export const cilResizeBoth = ["24 24","<path d='M18.97 9.97l-2.368 2.368-4.939-4.939 2.383-2.383-1.265-1.265h-9.031v9l1.28 1.28 2.39-2.39 4.939 4.939-2.405 2.405 1.265 1.265h9.031v-9zM18.75 18.75h-6.439l2.17-2.17-7.061-7.061-2.17 2.17v-6.439h6.439l-2.148 2.148 7.061 7.061 2.148-2.148z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-resize-both.js
// module id = null
// module chunks = 